import { Grid } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import WizardContainer from "../../../components/Wizard/WizardContainer";

type Props = {
    children: ReactNode
}

const AIWizard = ({ children }: Props) => {
    //const { setPromptDetails, setResult } = useAIAssistant();

    //const [step, setStep] = useState(0);
    //const DEBUGGING = false;

    //const onNextStep = async () => {
    //    if (step !== 3) {
    //        setStep(step => step + 1);
    //    } else {
    //        setStep(0);
    //        onClose();
    //    }
    //}

    //const onPreviousStep = async () => {
    //    if (step !== 0) {
    //        setStep(step => step - 1);
    //    }
    //}

    return (
        <WizardContainer>
            <Grid container sx={{ height: '100%' }}>
                {children}
            </Grid>
        </WizardContainer>
    )
}

export default AIWizard;